<template>
  <div class="flex flex-col">
    <div v-if="search" class="w-full py-3 border-b dark:border-gray-800 relative px-3">
      <text-field v-model="query" :placeholder="$t('general.filter')" leading="search" />
      <div class="absolute right-0 transform mr-2 top-1/2 -translate-y-1/2">
        <o-button
          v-if="query.length"
          size="xs"
          variant="danger"
          transparent
          flat
          icon="x"
          @click="clearQuery()"
        />
      </div>
    </div>

    <div class="flex-shrink flex-grow h-1/2 text-base leading-6 focus:outline-none sm:text-sm sm:leading-5 pt-3">
      <o-scroll clas="pt-6">
        <template
          v-for="(category, index) in filtered"
          :key="index"
        >
          <div v-if="category.options.length">
            <p v-if="!selectCategory && category.label" class="opacity-70 text-xs uppercase tracking-wider mt-2 px-4">
              {{ category.label }}
            </p>
            <checkbox-group-field
              v-model="currentValue"
              :options="category.options"
              :scroll="false"
              :select-all="selectCategory"
              :select-all-label="category.label || $t('general.other')"
              :checkbox-base-class="checkboxBaseClass"
            >
              <template #option="{ option }">
                <slot name="option" :option="option" />
              </template>
            </checkbox-group-field>
          </div>
        </template>
      </o-scroll>
    </div>
  </div>
</template>

<script setup lang="ts">
import Fuse from 'fuse.js'

import CheckboxGroupField from './CheckboxGroup.vue'
import TextField from './Text.vue'

interface Props {
  modelValue?: any[] | Record<string, any> | string
  options: Record<string, any> | any[]
  search?: boolean
  selectCategory?: boolean
  checkboxBaseClass?: string | Record<string, any> | string[]
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  search: false,
  selectCategory: false,
  checkboxBaseClass: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
  (e: 'change', value: any): void
}>()

const query = ref('')

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value: any) {
    emit('update:modelValue', value)
  },
})

const filtered = computed(() => {
  const categories = props.options

  if (query.value.length) {
    const arrays = Object.values(categories).map(({ options }: any) => options)
    const items = ([] as any[]).concat(...arrays)
    const fuse = new Fuse(items, {
      keys: ['text', 'info', 'value'],
    })
    const results = fuse.search(query.value)
    return [
      { options: results.map(({ item }) => item) },
    ]
  }

  return categories
})

watch(currentValue, (val) => {
  emit('change', val)
})

function clearQuery () {
  query.value = ''
}
</script>
